const COOKIE_NAME__LOCALE = 'skillsvue-locale'

const config = {
  COOKIE_NAME__LOCALE,

  percentiles: [
    {
      code: 'P25',
      text: 'percentiles.25th'
    },
    {
      code: 'P50',
      text: 'percentiles.50th'
    },
    {
      code: 'P75',
      text: 'percentiles.75th'
    }
  ],
  defaultLocale: 'en',
  supportedLocales: ['en', 'zh-CN']
}

export default config
